/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import create from "zustand";
import { isNumber, isEmpty, map } from "lodash";
import { useEffect, useState, React } from "react";
import "./Submenu.css";
import { useInfoPromptState } from "./InfoPrompt";

const store = (set, get) => ({
  buttonsConfig: null,
  setButtonsConfig: (config) => {
    const { buttonsConfig: oldButtonsConfig, buttonSelected } = get();
    const newButtonsConfig = config;
    if (oldButtonsConfig != null)
      newButtonsConfig.setInteractivePage = oldButtonsConfig.setInteractivePage;
    set({ buttonsConfig: newButtonsConfig });
    if (
      isNumber(buttonSelected) &&
      newButtonsConfig?.menu[buttonSelected]?.menu?.length > 0
    ) {
      set({ submenuVisible: true });
    }

    if (!isEmpty(newButtonsConfig?.default)) {
      set({ buttonsSelectedState: { [newButtonsConfig?.default]: true } });
    }
  },
  submenuVisible: false,
  correlationConfig: {},
  setCorrelationConfig: (correlationConfig) => set({ correlationConfig }),
  correlationFlag: false,
  setCorrelationFlag: (correlationFlag) => set({ correlationFlag }),
  setSubmenuVisible: (submenuVisible) => set({ submenuVisible }),
  buttonSelected: "",
  setbuttonSelected: (buttonSelected) => set({ buttonSelected }),
  childbuttonSelected: null,
  setchildbuttonSelected: (childbuttonSelected) => set({ childbuttonSelected }),
  buttonsSelectedState: {},
  setbuttonsSelectedState: (buttonsSelectedState) =>
    set({ buttonsSelectedState }),
});

export const useSubmenuStore = create(store);

const Submenu = () => {
  const showInfo = useInfoPromptState((s) => s.showInfo);
  const [arMode, setArMode] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("ar") === "1") {
      setArMode(true);
    } else {
      setArMode(false);
    }
  }, []);
  const buttonsConfig = useSubmenuStore((state) => state.buttonsConfig);
  const correlationFlag = useSubmenuStore((state) => state.correlationFlag);
  const correlationConfig = useSubmenuStore((state) => state.correlationConfig);
  const [submenuVisible, setSubmenuVisible] = useSubmenuStore((state) => [
    state.submenuVisible,
    state.setSubmenuVisible,
  ]);
  const [buttonSelected, setbuttonSelected] = useSubmenuStore((state) => [
    state.buttonSelected,
    state.setbuttonSelected,
  ]);
  const [childbuttonSelected, setchildbuttonSelected] = useSubmenuStore(
    (state) => [state.childbuttonSelected, state.setchildbuttonSelected]
  );

  const [buttonsSelectedState, setbuttonsSelectedState] = useSubmenuStore(
    (state) => [state.buttonsSelectedState, state.setbuttonsSelectedState]
  );

  useEffect(() => {
    if (buttonsConfig != null) {
      buttonsConfig?.menu?.forEach((outerelement) => {
        if (childbuttonSelected == null)
          if (outerelement.name === "colorChangeIcon") {
            const defaultIndex = outerelement.menu.findIndex(
              (menuItem) => menuItem.default === 1
            );
            if (defaultIndex > -1) {
              setchildbuttonSelected(defaultIndex);
            }
          }
      });
      if (buttonSelected === "" && buttonsConfig.setInteractivePage) {
        console.log("calling setinteractive page from submenu with empty");
        buttonsConfig.setInteractivePage();
      }
    }
  }, [
    buttonsConfig,
    childbuttonSelected,
    setbuttonsSelectedState,
    setchildbuttonSelected,
    buttonSelected,
  ]);

  const firstLayerOnClick = (oldbuttonsSelectedState) => {
    return (buttonConfig, index, isSelected) => {
      const localButtonSelectedState = {};
      if (!correlationFlag) {
        if (buttonConfig.name === "fullEmptyIcon") {
          localButtonSelectedState.openCloseIcon = true;
        } else if (buttonConfig.name === "openCloseIcon") {
          if (!isSelected) localButtonSelectedState.fullEmptyIcon = true;
          else
            localButtonSelectedState.fullEmptyIcon =
              oldbuttonsSelectedState.fullEmptyIcon || false;
        } else {
          localButtonSelectedState.fullEmptyIcon =
            oldbuttonsSelectedState.fullEmptyIcon || false;
          localButtonSelectedState.openCloseIcon =
            oldbuttonsSelectedState.openCloseIcon || false;
        }
        localButtonSelectedState[buttonConfig.name] = !isSelected;
      } else {
        localButtonSelectedState.fullEmptyIcon =
          oldbuttonsSelectedState.fullEmptyIcon;
        localButtonSelectedState.openCloseIcon =
          oldbuttonsSelectedState.openCloseIcon;
        localButtonSelectedState[buttonConfig.name] = !isSelected;
        // Only runs when we have Correlation config for button
        if (!isEmpty(correlationConfig)) {
          map(Object.keys(correlationConfig), (button) => {
            const currentCorrelationConfig = correlationConfig[button];
            const connectedIcon = correlationConfig[button]?.iconName;
            const currentState = !isSelected
              ? currentCorrelationConfig?.onClick
              : currentCorrelationConfig?.onUnClick;
            // When the button which has correlation config is clicked it clicks other button
            if (currentState && buttonConfig.name === button) {
              localButtonSelectedState[connectedIcon] = true;
            }
          });
        }
      }

      // console.log("submenu firstlayeronclick", index, oldbuttonsSelectedState);
      setbuttonsSelectedState({ ...localButtonSelectedState });
      // if (buttonConfig.menu.length > 0) {
      setbuttonSelected(index);
      setSubmenuVisible(
        buttonConfig.menu.length > 0 &&
        localButtonSelectedState[buttonConfig.name]
      );
      if (buttonsConfig.setInteractivePage) {
        buttonsConfig.setInteractivePage(buttonConfig.name);
      }
      // }
    };
  };
  const secondLayerOnClick = (buttonConfig, index) => {
    setchildbuttonSelected(index);
    if (buttonsConfig.setInteractivePage) {
      buttonsConfig.setInteractivePage(
        buttonsConfig?.menu?.[buttonSelected].name,
        buttonConfig.name
      );
    }
  };
  useEffect(() => {
    console.info("rito", showInfo);
  }, [showInfo]);
  if (buttonsConfig && buttonsConfig.menu)
    return (
      <div
        className="submenu-container"
        style={showInfo ? { visibility: "hidden" } : { visibility: "visible" }}
      >
        <div
          className={arMode ? "button-firstlayer-ar" : "button-firstlayer-xr"}
        >
          {buttonsConfig?.menu?.map((firstLevelButtonConfig, index) => {
            const buttonIndex = `${firstLevelButtonConfig.name}_${index}`;
            console.log(
              "🚀 ~ file: Submenu.js ~ line 124 ~ {buttonsConfig.menu.map ~ firstLevelButtonConfig",
              firstLevelButtonConfig
            );
            return (
              firstLevelButtonConfig.enabled !== false && (
                <MyButton
                  key={buttonIndex}
                  config={firstLevelButtonConfig}
                  index={index}
                  isSelected={
                    buttonsSelectedState[firstLevelButtonConfig.name] || false
                  }
                  onClick={firstLayerOnClick(buttonsSelectedState)}
                  imgClassName="button-image"
                />
              )
            );
          })}
        </div>

        <div className="button-secondlayer">
          {submenuVisible &&
            buttonsConfig?.menu[buttonSelected]?.menu.map(
              (secondLevelButtonConfig, index) => {
                const childButtonIndex = `${secondLevelButtonConfig.name}_${index}`;
                return (
                  secondLevelButtonConfig.enabled !== false && (
                    <MyButton
                      key={childButtonIndex}
                      config={secondLevelButtonConfig}
                      index={index}
                      onClick={secondLayerOnClick}
                      isSelected={childbuttonSelected === index}
                      imgClassName="color-image"
                    />
                  )
                );
              }
            )}
        </div>
      </div>
    );

  return null;
};

const MyButton = ({ config, index, isSelected, onClick, imgClassName }) => {
  const [prevState, setprevState] = useState(null);
  console.log(
    "🚀 ~ file: Submenu.js ~ line 168 ~ MyButton ~ prevState",
    prevState
  );

  useEffect(() => {
    if (
      isSelected !== undefined &&
      prevState != null &&
      prevState !== isSelected
    ) {
      if (isSelected) config.onClick();
      else config.onUnClick();
    }
    setprevState(isSelected);
  }, [isSelected, config, prevState]);
  return (
    <button type="button">
      <img
        className={imgClassName}
        src={isSelected ? config.iconSelected : config.icon}
        alt=""
        onClick={() => {
          onClick(config, index, isSelected);
        }}
      />
    </button>
  );
};

export default Submenu;
